import { useEffect, useRef } from 'react'
import { bootstrapPaymentReturn, isPaymentReturnSearch } from '@/shared/lib/paymentReturnBootstrap'
import { readWindowPathname, readWindowSearchRecord } from '@/shared/lib/paymentReturnHandler'

/**
 * Proactively refreshes CSRF when the SPA loads after a PSP redirect so parallel
 * keep-alive / cart / checkout calls do not hit a stale token.
 */
export function PaymentReturnBootstrap() {
  const handledKeyRef = useRef('')

  useEffect(() => {
    const pathname = readWindowPathname()
    const record = readWindowSearchRecord()
    if (!isPaymentReturnSearch(record)) {
      return
    }

    const key = `${pathname}:${JSON.stringify(record)}`
    if (handledKeyRef.current === key) {
      return
    }
    handledKeyRef.current = key
    void bootstrapPaymentReturn()
  }, [])

  return null
}
